import { BlogPostContent } from '@/types/blog';
import { introSection } from './sections/intro';
import { neuroplastizitaetSection } from './sections/neuroplastizitaet';
import { epigenetikSection } from './sections/epigenetik';
import { duoSection } from './sections/duo';
import { fazitSection } from './sections/fazit';

export const content: BlogPostContent = {
  sections: [
    introSection,
    neuroplastizitaetSection,
    epigenetikSection,
    duoSection,
    fazitSection
  ]
};
